import { Timeline } from "../../components/Timeline";
import { useGetUserInteractionsByIdQuery } from "../../services/userInteractions"
import UserInteractionItem from "./UserInteractionItem";
import { LoadingView } from "../../components";
import { useStyletron } from "baseui";
import { LabelMedium } from "baseui/typography";
import { FormattedMessage, useIntl } from "react-intl";
import { EmptyState } from "../../components/EmptyState";
import { endOfDay, endOfHour, startOfDay } from "date-fns";

const UserInteractionsTimeline = (props: { resourceGroupId: string, id: string, start: Date, end: Date }) => {
    const [, theme] = useStyletron();
    const intl = useIntl();
    const { data, isLoading, isSuccess, error } = useGetUserInteractionsByIdQuery({
        id: props.id,
        resourceGroupId: props.resourceGroupId,
        start: startOfDay(props.start).toISOString(),
        end: endOfDay(props.end).toISOString()
    })

    return (
        <>
            <LabelMedium marginBottom={theme.sizing.scale200}>
                <FormattedMessage id='UserInteractions.recentUserInteractions' defaultMessage={'Recent user interactions'}></FormattedMessage>
            </LabelMedium>
            <LoadingView isLoading={isLoading} isSucess={isSuccess} error={error}>
                {data?.length === 0 &&
                    <EmptyState header={intl.formatMessage({ id: 'UserInteractions.noUserInteractionsFound', defaultMessage: 'No user interactions found' })}></EmptyState>
                    }
                <Timeline >
                    {data?.map((v) => (<UserInteractionItem resourceGroupId={props.resourceGroupId} backgroundColor={backgroundSelector(v, theme)} {...v}></UserInteractionItem>))}
                </Timeline>
            </LoadingView>
        </>
    )
}

export default UserInteractionsTimeline;

const backgroundSelector = (props: any, theme: any): string | undefined => {
    switch (props.type) {
        case 'Users.IntegrationEvents.DigitalTwinChanged':
            return theme.colors.backgroundSecondary;
        case 'Users.IntegrationEvents.DigitalTwinCreated':
            return theme.colors.accent50;
        default:
            return undefined;
    }
}